import { useQuery } from "@tanstack/react-query";
import { Intent } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { intentQueryKeys } from "./keys";


const getData = async (agentId: number, skillId?: number) => {
    if (!skillId) {
        return [];
    }
    const res = await intentRepository.find(agentId, skillId);
    return res.data?.data;
};

export const useIntents = (agentId: number, skillId?: number) => {
    return useQuery<Intent[]>({
        queryKey: intentQueryKeys.intents(agentId, skillId),
        queryFn: async () => getData(agentId, skillId),
        retry: false
    });
};
